import { logger } from 'utils/logger';
import * as Sentry from '@sentry/react';
import { isError } from 'utils/types';

export const GENERIC_JANUS_ERROR = (source: string) => (error: unknown, response?: Response) => {
  const { name, constraint } = (error ?? {}) as { name?: string; constraint?: string };
  let message: string | undefined;
  if (isError(error)) {
    message = error.message;
  } else if (typeof error === 'string') {
    message = error;
  }

  // OverconstrainedError has an empty .message; name and constraint carry the detail.
  let details = [name, message, constraint && `constraint: ${constraint}`]
    .filter(Boolean)
    .join(' | ');
  if (!details) {
    try {
      details = typeof error === 'object' ? JSON.stringify(error) : String(error);
    } catch {
      details = String(error);
    }
  }

  logger.remote({ system: true }).error(`WebRTC client error in ${source}:`, details, response);

  // NotAllowedError = user denied the camera/mic prompt; expected, not an app fault.
  if (name === 'NotAllowedError') {
    return;
  }

  Sentry.captureException(isError(error) ? error : new Error(`${source}: ${details}`), {
    ...(response && {
      extra: {
        response,
      },
    }),
  });
};

export const NO_ROOM_ID = () => new Error('No room ID set for RTCClient');
export const NO_ROOM_PIN = () => new Error('No room pin set for RTCClient');
export const NO_PUBLISHING_FEED = (handle: string) =>
  new Error(`No publishing feed identified by "${handle}" present`);
export const JOIN_ROOM_ERROR = (details: string) => new Error(`Can't join room: ${details}`);

export const NO_REPLICATED_CONNECTION = (handle: string) =>
  new Error(`No media server connection identified by handle=${handle} present`);
